import type { MerchantUsersRepositoryState } from "./types";

export const stateFactory: () => MerchantUsersRepositoryState = () => ({});
